import axios from 'axios'

const configValue: string = process.env.REACT_APP_API_URL as string
const apiService = axios.create({
  baseURL: `${configValue}api/`,
})

apiService.interceptors.response.use(undefined, (error) => {
  if (error.response.status === 401 && window.location.pathname !== '/login') {
    localStorage.clear();

    window.location.href = '/login';
  }
  return Promise.reject(error);
});

apiService.interceptors.request.use(async (config) => {
  const token = localStorage.getItem('token')

  if (token) {
    config.headers = {
      Accept: 'application/json',
      ContentType: 'application/json',
      Authorization: `Bearer ${token}`
    }
  }

  return config
})

export default apiService
